exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1MQo232OA2aiiwcbNZL44A{margin-left:5px}", "", {"version":3,"sources":["/home/runner/work/frontend/frontend/src/App/components/fields/SimpleCheckBox/styles.css"],"names":[],"mappings":"AAGA,yBACE,eAAiB,CAClB","file":"styles.css","sourcesContent":[":local(.container) {\n}\n\n:local(.label) {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "_2in0xqYu2TEggl4gLn67YT",
	"label": "_1MQo232OA2aiiwcbNZL44A"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/App/components/fields/SimpleCheckBox/styles.css
// module id = 2049
// module chunks = 12 22 46 47